import { UiAnimatedHeroSectionModel } from "../../models";

import {
    mockAdfDocument,
    mockAdfHeading,
    mockAdfParagraph,
    mockAdfText,
    mockUiEmailSignupModel,
    mockUiEmailSignupModelContent,
    mockUiModalModel,
    mockUiModalModelContent,
    mockUiRotatingImagesModel,
    mockLinkButtonThemeModel,
    mockLinkButtonThemeModelContent,
    mockUiButtonModel,
    mockUiButtonModelContent
} from "./";

export function mockUiAnimatedHeroSectionModel({
    id = "stack-1234",
    type = "uiAnimatedHeroSection",
    locale = "en",
    content = mockUiAnimatedHeroSectionModelContent()
}: Partial<UiAnimatedHeroSectionModel> = {}): UiAnimatedHeroSectionModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiAnimatedHeroSectionModelContent =
    UiAnimatedHeroSectionModel["content"];

export function mockUiAnimatedHeroSectionModelContent({
    entryTitle = "Demo animated hero section",
    labels = [
        "Analytics",
        "Design",
        "Engineering",
        "HR",
        "Marketing",
        "Operations",
        "Sales",
        "Startups",
        "Support"
    ],
    content = mockAdfDocument({
        content: [
            mockAdfHeading({
                content: [mockAdfText({ text: "Work differently, together." })]
            }),
            mockAdfParagraph({
                content: [
                    mockAdfText({
                        text: "Collaborate, manage projects, and reach new productivity peaks. From high rises to the home office, the way your team works is unique—accomplish it all with Trello."
                    })
                ]
            })
        ]
    }),
    images = mockUiRotatingImagesModel(),
    callsToAction = [
        mockUiEmailSignupModel({
            content: mockUiEmailSignupModelContent({
                buttonText: "Sign up - it’s free",
                constrainInputWidth: true
            })
        }),
        mockUiModalModel({
            content: mockUiModalModelContent({
                modalTrigger: mockUiButtonModel({
                    content: mockUiButtonModelContent({
                        text: "Watch video",
                        buttonTheme: mockLinkButtonThemeModel({
                            content: mockLinkButtonThemeModelContent({
                                style: "No padding",
                                decorator: "Play"
                            })
                        })
                    })
                })
            })
        })
    ],
    background = [
        {
            color: "P400",
            properties: [
                {
                    clip: "border-box",
                    size: {
                        units: {
                            unit: "%",
                            width: 100,
                            height: 100,
                            isAutoWidth: false,
                            isAutoHeight: false
                        },
                        keyword: "auto",
                        fieldType: "keyword"
                    },
                    image: {
                        type: "gradient",
                        image: {
                            id: "",
                            value: "none"
                        },
                        gradient: {
                            angle: 60,
                            value: "WP400"
                        }
                    },
                    origin: "padding-box",
                    repeat: "repeat",
                    position: {
                        units: {
                            unit: "%",
                            vertical: 0,
                            horizontal: 0
                        },
                        keywords: {
                            vertical: "top",
                            horizontal: "left"
                        },
                        fieldType: "units"
                    },
                    blendMode: "normal",
                    attachment: "scroll"
                }
            ],
            breakpoints: ["lg", "xl", "md", "sm", "xs"]
        }
    ],
    ...optionals
}: Partial<UiAnimatedHeroSectionModelContent> = {}): UiAnimatedHeroSectionModelContent {
    return {
        entryTitle,
        labels,
        content,
        images,
        callsToAction,
        background,
        ...optionals
    };
}
